"use strict";

exports.__esModule = true;
var _Landing = require("./Landing");
Object.keys(_Landing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Landing[key]) return;
  exports[key] = _Landing[key];
});